import React from 'react'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import TestimonyCard from 'components/molecules/TestimonyCard'

import { arrayOf, object } from 'prop-types'
import config from 'config'

const { assets_url: assetsUrl } = config

const MajorTestimonies = ({ testimonies }) => (
  <div id="testimonies" className="major-testimonies">
    <SectionContainer marginTop={120} paddingBottom={80} backgroundColor="transparent">
      <Container>
        <SectionTitle title="Testimoni" align="left" />
        <div className="major-testimonies__list">
          {
            testimonies.map((testimony, idx) => {
              const testimonyProp = {
                name: testimony.student_name,
                img: testimony.student_photo_url,
                imgAlt: testimony.student_name,
                testimony: testimony.description,
                schoolName: testimony.school_name,
                year: testimony.year,
                majorName: testimony.study_field_name,
                direction: 'column',
              }
              return (<TestimonyCard {...testimonyProp} key={`mjr-testimony-${idx}`}/>)
            })
          }
        </div>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .major-testimonies {
          background-image: url(${assetsUrl}/assets/img/major_detail/triple-rect-accent.svg);
          background-repeat: no-repeat;
          background-position: center right; 
          background-color: #fff;
        }
      `}
    </style>
  </div>
)

MajorTestimonies.propTypes = {
  testimonies: arrayOf(object),
}

export default MajorTestimonies
